/**
 * Keeps aria-hidden carousel cells out of the tab order.
 *
 * Flickity hides off-screen cells with aria-hidden="true" but leaves the links
 * and buttons inside them focusable, which fails the axe "aria-hidden-focus"
 * rule. Only tabindex is touched, so mouse and touch behaviour is unchanged.
 */
(function () {
  'use strict';

  var CELLS = '.flickityt4s-slider > [aria-hidden], .flickity-slider > [aria-hidden]';
  var SLIDERS = '.flickityt4s-slider, .flickity-slider';
  var FOCUSABLE = 'a[href], area[href], button, input, select, textarea, iframe, object, embed, summary, [contenteditable], [tabindex]';
  var STORE = 'data-t4s-a11y-tabindex';

  function targets(cell) {
    var list = Array.prototype.slice.call(cell.querySelectorAll(FOCUSABLE));
    if (cell.matches(FOCUSABLE)) list.unshift(cell);
    return list;
  }

  function untab(cell) {
    targets(cell).forEach(function (el) {
      if (el.hasAttribute(STORE)) return;
      el.setAttribute(STORE, el.getAttribute('tabindex') || '');
      el.setAttribute('tabindex', '-1');
    });
  }

  function retab(cell) {
    targets(cell).forEach(function (el) {
      if (!el.hasAttribute(STORE)) return;
      var previous = el.getAttribute(STORE);
      el.removeAttribute(STORE);
      if (previous) el.setAttribute('tabindex', previous);
      else el.removeAttribute('tabindex');
    });
  }

  function sync(cell) {
    if (!cell.closest || !cell.parentElement || !cell.parentElement.matches(SLIDERS)) return;
    if (cell.getAttribute('aria-hidden') === 'true') untab(cell);
    else retab(cell);
  }

  function scan() {
    Array.prototype.slice.call(document.querySelectorAll(CELLS)).forEach(sync);
  }

  // Flickity toggles aria-hidden on cells that are already in the DOM, so
  // watching the attribute covers carousels built after this script runs.
  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) sync(mutations[i].target);
  }).observe(document.documentElement, {
    subtree: true,
    attributes: true,
    attributeFilter: ['aria-hidden']
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  window.addEventListener('load', scan);
})();
